export default __webpack_public_path__ + "static/media/hht1_ep05_timeline_q03_b.0e391959.png";